import React, { use, useEffect, useState } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CartList from "./CartList/Component";
import PaymentBottomBar from "./BottomPayment/component";


import AutoApplyPopup from "./Popup/AutoApplyPopup";
import CouponsList from "./CouponList/Component";
import CouponDialog from "./Popup/CouponPopup";
import WaitingLoder from "../../Loader/component";
import { useWebSocket } from "../../Websocket/useWebSocket";
import PaymentStatus from "./PaymentStatus/Component";
import { Box, Avatar, Typography,Button } from "@mui/material";
import LinkIcon from "../../assets/Link.png"

import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";
import { setWebSocketData } from "../../Websocket/webSocketAction";
import Delete from '../../assets/delete.png'
import EmptyCartDialog from "./Popup/EmptyCartDialog";
import LowBalanceModal from "./Popup/2";
import AddGoogleNumber from "../Userprofile/AddGoogleNumber";
import GoogleSuccessModal from "../Userprofile/GoogleSuccessModal";
import GoogleNumberOtpModal from "../Userprofile/GoogleNumberOtpModal";

const baseURL="https://api-prod.daalchini.co.in"
const defaultPgName = localStorage.getItem("defaultPgName");

const MyHeader = ({ handleBack,handleEmpty }) => {
   
  return (
    <Box display="flex" alignItems="center" p={2} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
      <Box display={"flex"} width={"100%"} alignItems={"center"}     justifyContent="space-between">
      <Box display={"flex"}>
      <IconButton onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
        My Cart
      </Typography>
      </Box>
      <img src={Delete}  onClick={handleEmpty} style={{width:"30px"}}/>
      </Box>
    </Box>
  );
};




const MyCartContainer=()=>{
  const { makeApiRequest } = useApiRequest();
  const dispatch = useDispatch()
   const { wsData, startWebSocket } = useWebSocket();
    const navigate = useNavigate();
    const [cartList,setCartList]=useState([])
    const [machineId,setMachineId]=useState(null)
    const [paymentOptionData,setPaymentOption]=useState([])
    const [showCoupoListFlag,setShowCoupoListFlag]=useState(false)
    const [couponsList,setCouponsList]=useState([])
    const [couponCode,setCouponCode]=useState("tahzeeb")
    const [couponAppliedSuccess,setCouponAppliedSuccess]=useState(false)
    const [showCouponPopFlag,setShowCouponPopFlag]=useState(false)
    const [cartReward,setCartReward]=useState(null)
    const [removebtnflag,setRemovebtnflag]=useState(true)
    const [loader,setLoader]=useState(false)
    const [paymentStatusFlag,setPaymentStatusFlag]=useState(false)
    const [orderSucessStatus,setOrderSucessStatus]=useState(false)
    const [orderSucessOrderId,setOrderSucessOrderId]=useState(null)
    const [orderSucessPaymentMethod,setOrderSucessPaymentMethod]=useState(null)
 const cartmachineId=localStorage.getItem("machineId")
 const [fullObjectRewardCart,setFullObjectRewardCart]=useState(null)
 const [openEmptyCart,setOpenEmptyCart]=useState(null)
 const [orderAmount,setOrderAmount]=useState(null)
const [flagLowBalance,setFlagLowBalance]=useState(null)

  const [google_Pop_flag, setGoogle_Pop_flag] = useState(false);
    const [google_OTP_Pop_flag, setGoogle_OTP_Pop_flag] = useState(false);
    const [google_success_flag, setGoogle_success_flag] = useState(false);

      const [number, setNumber] = useState("");
      const [otp, setOtp] = useState("");
      const [google_requestId, setGoogle_requestId] = useState(null);
      const [numberError, setNumberError] = useState(false);
      const [otpError, setOtpError] = useState(false);
      const [numberErrorMsg, setNumberErrorMsg] = useState("");
      const [otpErrorMsg, setOtpErrorMsg] = useState("");
        const location = useLocation();
       
      
        const searchParams = new URLSearchParams(location.search);
        const machineIdParams = searchParams.get("machineId");
        const uuid = searchParams.get("value");
      useEffect(()=>{
  // window.location.reload()

      },[])
    
        useEffect(() => {
      //console.log("CONSOLE NUMBER ->> 3");
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }, []);
  const handleStartWebSocket = (orderId) => {
   
    const url = `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`;
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
   


    startWebSocket(url, (data, navigate) => {
      //console.log("WebSocket received:", data);
      dispatch(setWebSocketData(data));
      setPaymentStatusFlag(true)
      setOrderSucessStatus(data?.success)
      setOrderSucessOrderId(data?.orderId)
      setOrderSucessPaymentMethod(data?.pgName)
      setLoader(false)

      return <>
      <PaymentStatus/>
      </>

      
    });
  };



    useEffect(()=>{
      fetchUserDetails()
        fetchPreCard()
        fetchAutoCoupon()
        
    },[])




const fetchPreCard = async (e) => {
  setLoader(true)
  e?.stopPropagation?.();
  //setLoader(true);

  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  // 🔒 Ensure user is authenticated
  if (!token) {
    //setLoader(false);
    toast.error("Please login to continue");
    return navigate("/login");
  }

  // 🚀 Make API request using reusable helper
  makeApiRequest({
    url: `${baseURL}/consumerbe/api/v2/cart`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId || "",
    },
    handleSuccess: handleResponsePreCard,
    handleError: handleErrorPreCard,
  });
};


const handleResponsePreCard = (response) => {
  setLoader(false)
  try {
    //console.log("response",response.headers.machineid)
    const CartMachineId = response?.headers?.machineid;
    const cartId = response?.headers["cart-id"];
    const data = response?.data?.data || {};
     //console.log("back",!(response.data.data.items[0]),machineId,`/items?machineId=${machineId}&value=null`)
     
     if(!(response.data.data.items[0])){
       if(localStorage.getItem("SodexoPaymentRequestId")){

navigate(`/pickupOptions/${localStorage.getItem("orderId")}`)
localStorage.removeItem("SodexoPaymentRequestId")
       }
       else{
        navigate(`/items?machineId=${localStorage.getItem("machineId")}&value=null&showItems=true`)
       }
    } 

    setFullObjectRewardCart(response.data)
setCartList(response.data.data.items)
setCartReward(response.data.data.reward)
setMachineId(CartMachineId)
if(machineIdParams){
  PaymentOptionApi(machineIdParams)
}
else{
PaymentOptionApi(CartMachineId)

}
    // 💾 Update localStorage
    localStorage.setItem("card_id", cartId);
    localStorage.setItem("machineId", CartMachineId);

    // 🔄 Call dependent APIs
    //PaymentOptionApi(machineId);

 /*    if (!Guest_clientId) {
      //setLoader(true);
      //fetchCoupon();
    } */
  } catch (err) {
   // console.error("Error handling PreCard response:", err);
  } finally {
    //setLoader(false);
  }
};

const handleErrorPreCard = (error) => {
   setLoader(false)
 // console.error("PreCard API error:", error);
  //setLoader(false);
  toast.error("Failed to load cart data. Please try again.");
};



const fetchAutoCoupon = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
 

  if (!UserJWTAuth) return navigate("/login");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/coupon/auto-applicable`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },
    handleSuccess: handleResponseAutoCoupon,
    handleError: handleErrorAutoCoupon,
  });
};
const handleResponseAutoCoupon=(res)=>{
 // console.log("handleResponseAutoCoupon",res.data.data)
  if(res.data.data&&res.data.data[0])
  ApplyCoupon(res.data.data[0].couponName,true)

}

const handleErrorAutoCoupon=()=>{

}




const fetchCouponsList = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
 setShowCoupoListFlag(true)

  if (!UserJWTAuth) return navigate("/login");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/coupon`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },
    handleSuccess: handleResponseCouponsList ,
    handleError: handleErrorCouponsList ,
  });
};


const handleResponseCouponsList=(res)=>{
  //console.log("handleResponseCouponsList",res.data.data)
setCouponsList(res.data.data)
}


const handleErrorCouponsList=()=>{
  
}

const ApplyCoupon = (couponName,auto) => {
  setCouponCode(couponName)
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
  const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);

  if (!token) return navigate("/login");

  //setLoader(true);

  makeApiRequest({
    url: `${baseURL}/consumerbe/api/v2/cart/coupon`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
    },
    data: {
      couponName: couponName,
      pgName: defaultPgId,
    },
    handleSuccess: (res) => {
      handleResponseApplyCoupon(res,auto);
      //setLoader(false);
    },
    handleError: (error) => {
      //console.log("handleErrorApplyCoupon",error)
      handleErrorApplyCoupon(error);
      //setLoader(false);
    },
  });
};


const handleResponseApplyCoupon=(res,auto)=>{
  if(auto){
 setRemovebtnflag(false)
  }
  setCouponAppliedSuccess(true)
  setShowCouponPopFlag(true)
  setShowCoupoListFlag(false)
}

const handleErrorApplyCoupon=(error)=>{

setCouponAppliedSuccess(false)
 setShowCouponPopFlag(true)
// setShowCoupoListFlag(false)
}



const PaymentOptionApi = (CartMachineId) => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
 

  if (!UserJWTAuth) return navigate("/login");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/payment/option?machineId=${CartMachineId}&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },
    handleSuccess: handleResponsePaymentOption,
    handleError: handleErrorPaymentOption,
  });
};

const handleResponsePaymentOption=(res)=>{
  //console.log("handleResponsePaymentOption",res.data.data)
  
setPaymentOption(res.data.data)

}
const handleErrorPaymentOption=()=>{

}


  const handleCartOpertation = (e, index, slot_id, currentCount, operation) => {
    //console.log("handleCartOpertation",index, slot_id, currentCount, operation)
    e.stopPropagation();
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return navigate("/login");

    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

   /*  if ((preCart?.length > 0) || (preCartCombo?.length > 0)) {
      setReplaceSlot({ slot_id, index });
    } */

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=${machineId}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slot_id), count: payloadCount }],
      handleSuccess: (res) => handleResponseAddIntoCart(res, slot_id, operation),
      handleError: handleErrorAddIntoCart,
    });
  };

const handleResponseAddIntoCart=()=>{
fetchPreCard()
}

const handleErrorAddIntoCart=(error)=>{
    //console.log("handleErrorAddIntoCart",error.response.data.status.message)
    toast.error(`${error.response?.data?.status?.message}`, {
      position: "top-right",
      autoClose: 1500,
    });
}

   const CouponText=()=>{
        return(
            <>
             Coupon code <strong>{couponCode}</strong> does not exist for this item.
          Please try again!
          </>
        )
    }

const handleCloseCouponPopup=(e)=>{
setShowCouponPopFlag(false)
fetchPreCard()
}

const razorpay = (orderId,amount) => {

  const razorpayMethod =
    defaultPgName === "R_CARD"
      ? "card"
      : defaultPgName === "R_WALLET"
      ? "wallet"
      : "upi";

      //console.log("orderAmount",amount)
  const payAmount = amount * 100; // Use actual amount
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const mobileNo = JSON.parse(localStorage.getItem("mobileNo")) || "";

  const options = {
    key: "rzp_live_ZVpG4pXQKTLFCS",
    amount: payAmount.toString(),
    currency: "INR",
    name: "Daalchini",
    description: `Order ID: ${orderId}`,
    prefill: {
      email: "info@daalchini.co.in",
      contact: mobileNo,
      method: razorpayMethod,
    },
    theme: {
      color: "#432B2B",
      hide_topbar: false,
    },
    notes: {
      order_id: orderId,
    },

    // ✅ Razorpay success callback
    handler: function (response) {
      //console.log("Razorpay success response:", response);
      handlePaymentSuccess(response, orderId);

      const payload = {
        header: {
          oauthToken: UserJWTAuth,
          userkey: UserJWTAuth,
        },
        data: {
          request: {
            orderId,
            paymentGateway: defaultPgName || "RAZORPAY",
            paymentId: response.razorpay_payment_id || null,
            paymentStatus: response.razorpay_payment_id
              ? "SUCCESS"
              : "FAILED",
          },
        },
      };

      // Optionally: confirm payment on backend
      // makeApiRequest(payload);

      // ✅ Redirect to success page
      //window.location.href = `/payment-status?status=success&orderId=${orderId}`;
    },

    // ❌ Razorpay error callback
    onpaymenterror: function (error) {
      console.error("Razorpay error:", error);
      handlePaymentError(error);

      // ✅ Redirect to failure page
      //window.location.href = `/payment-status?status=failed&orderId=${orderId}`;
    },

    // ⚙️ Razorpay modal dismiss callback
    modal: {
      ondismiss: function () {
          navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`);
        //alert("Payment modal closed!");
        const container = document.getElementById("razorpay-container");
        if (container) container.remove();

        // Optional: navigate back to order page
        // window.location.href = "/myCart";
      },
    },
  };

  // 🔥 Open Razorpay modal
  const rzp = new window.Razorpay(options);
  setLoader(false);
  rzp.open();
};



  const handlePaymentError = (error) => {
   
    navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`);
 
  };

  const handlePaymentSuccess = (response,orderId) => {
      handleStartWebSocket(orderId)
  }


function getPgById(id) {
 // console.log("pgdata",paymentOptionData,id)
  //console.log("pgdata",paymentOptionData.find(item => item.pgId === id))
    return paymentOptionData.find(item => item.pgId === id);
}  

const InitiatedPaymentApi = (orderId,amount) => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  //const defaultPgId = localStorage.getItem("defaultPgId");
    const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);
    //console.log("pgData",defaultPgId)
const pgdata=getPgById(defaultPgId&&defaultPgId)
 // console.log("pgData",pgdata,defaultPgId)

  const OrderId = localStorage.getItem("orderId");
  const uuid = localStorage.getItem("uuid");

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/${orderId}/payment`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": uuid,
    },
    data: {
      pgId: defaultPgId,
    },
    handleSuccess: (res) => {
      //console.log("✅ Payment Initiated Successfully:", res);
      handleResponseInitiatedPayment(res,orderId,amount);
    },
    handleError: (err) => {
      //console.error("❌ Payment Initiation Failed:", err);
      handleErrorInitiatedPayment(err);
    },
  }); 
};

const handleResponseInitiatedPayment=(res,orderId,amount)=>{
const defaultPgName = localStorage.getItem("defaultPgName");
     if (
      "R_CARD" == defaultPgName ||
      "R_WALLET" == defaultPgName ||
      "R_UPI" == defaultPgName
    ) {
    
     // console.log("defaultPgName-----------------------------",defaultPgName)
      razorpay(orderId,amount); 
    }

         if ("SODEXO" == defaultPgName) {

localStorage.setItem("orderId",orderId)
      localStorage.setItem(
        "SodexoPaymentRequestId",
        res.data.data.sodexoRedirectOptions.requestId
      );
      window.location.replace(res.data.data.sodexoRedirectOptions.redirectUrl);

      handleStartWebSocket(orderId);
    }
handleStartWebSocket(orderId)
}

const handleErrorInitiatedPayment=()=>{

}

const CreateOrderApi = () => {
  setLoader(true);
//console.log("cartList----------",cartList)


const totalAmount = cartList.reduce(
  (sum, item) => sum + item.count * item.amount,
  0
);

//console.log("totalAmount--------------",totalAmount); // 22


  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const uuid = localStorage.getItem("uuid");
  const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);

  const pgdata = getPgById(defaultPgId);
  //console.log("pgData", pgdata, defaultPgId);

  // ----  ADD YOUR LOW BALANCE CHECK   ----
  const orderAmount = totalAmount; // <-- replace with your variable (order total)
  
  if (pgdata && (pgdata.pgId === 8 || pgdata.pgId === 9)) {
    // pgId 8 → WALLET , pgId 9 → LOYALTY WALLET
    if (pgdata.balance !== null && pgdata.balance < orderAmount) {
      //console.log("❌ Low Balance", pgdata.balance, orderAmount);
      setFlagLowBalance(true);
      setLoader(false);
      return; // stop API call
    }
  }
  // ---------------------------------------

  makeApiRequest({
    url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/${machineId}/order`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": uuid,
    },
    data: {
      type: "regular",
    },
    handleSuccess: (res) => {
      //console.log("✅ Order Created Successfully:", res.data.data.orderId);
      handleResponseCreateOrder(res);
    },
    handleError: (err) => {
      console.error("❌ Create Order Failed:", err);
      handleErrorCreateOrder(err);
      setLoader(false);
    },
  });
};


const handleResponseCreateOrder=(res)=>{

    const defaultPgId = parseInt(localStorage.getItem("defaultPgId"), 10);

  const pgdata = getPgById(defaultPgId);
  //console.log("pgData", pgdata, defaultPgId);
    if (pgdata && (pgdata.pgId === 8 || pgdata.pgId === 9)) {
    // pgId 8 → WALLET , pgId 9 → LOYALTY WALLET
    if (pgdata.balance !== null && pgdata.balance < res.data.data.amount) {
      //console.log("❌ Low Balance", pgdata.balance, res.data.data.amount);
      setFlagLowBalance(true);
      setLoader(false);
      return; // stop API call
    }
  }

  //console.log("orderAmount",res.data.data.amount)
  setOrderAmount(res.data.data.amount)
  InitiatedPaymentApi(res.data.data.orderId,res.data.data.amount)

}
const handleErrorCreateOrder=(err)=>{
    toast.error(`${err.response?.data?.status?.message}`, {
      position: "top-right",
      autoClose: 1500,
    });
}


if(showCoupoListFlag){
  return <CouponsList setShowCoupoListFlag={setShowCoupoListFlag} couponsList={couponsList} ApplyCoupon={ApplyCoupon} CouponText={CouponText}   showCouponPopFlag={showCouponPopFlag}  handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}/>
}

const RedirectAfterPaymentStatus=()=>{
navigate(`/pickupOptions/${orderSucessOrderId}`)

}

  const fetchUserDetails = () => {
      const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
    if (!token) return;

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/auth/user/profile/details`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: { oauthToken: `Bearer ${token}` },
      },
      handleSuccess: handleResponseUserDetails,
      handleError: handleErrorUserDetails,
    });
  };

  const handleResponseUserDetails = (res) => {
//console.log("handleResponseUserDetails",res.data.response)


    const data = res?.data?.response;
    if (data) {
      localStorage.setItem("referCode", data.referCode);
      //setProfileData(data);
    }
    setLoader(false);
  };

  const handleErrorUserDetails = (error) => {
    setLoader(false);
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      const google_jwt = localStorage.getItem("google_jwt");
      if(google_jwt) { 
        setGoogle_Pop_flag(true)

      } 
    } else {
      toast.error(
        error?.response?.data?.status || "Something went wrong",
        { position: "top-right", autoClose: 1000 }
      );
    }
  };



const handleBack=()=>{

 //console.log("machineId",cartmachineId)
  navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`)

}
    
//console.log("cartReward",cartReward,cartList)

  const clearPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/consumerbe/api/v2/cart",
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: () => {
        navigate(`/items?machineId=${localStorage.getItem("machineId")}&value=null&showItems=true`)
        setOpenEmptyCart(false)


      },
      handleError: showError,
    });
  };

const showError=()=>{
setOpenEmptyCart(false);
}
 const handleEmpty = () => {
    //console.log("Cart Emptied!");
     setOpenEmptyCart(true);
   
  };


const Close=()=>{
  //console.log("close low balance popup")
setFlagLowBalance(false)

}



  const closePop = () => {
    setGoogle_Pop_flag(false);
    navigate("/");
  };

  const closeOTpPop = () => {
    setGoogle_Pop_flag(true);
    setGoogle_OTP_Pop_flag(false);
  };


    const handle_Number = (e) => setNumber(e.target.value);
  
    const googleAddnumber = () => {
        const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
      if (number.length !== 10) {
        setNumberError(true);
        setNumberErrorMsg("Enter a valid mobile number");
        return;
      }
  
      setNumberError(false);
      makeApiRequest({
        url: `https://api-prod.daalchini.co.in/auth/user/authenticate`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": deviceId || "",
        },
        data: {
          request: {
            mobileNo: number,
            googleId: localStorage.getItem("gmail"),
          },
        },
        handleSuccess: (res) => {
          setGoogle_requestId(res.data.response.requestId);
          setGoogle_Pop_flag(false);
          setGoogle_OTP_Pop_flag(true);
        },
        handleError: (err) => {
          setNumberError(true);
          setNumberErrorMsg(err.response.data.statusMessage);
          toast.error(err.response.data.statusMessage, {
            position: "top-right",
            autoClose: 1000,
          });
        },
      });
    };
  
    const googleOtpSubmit = () => {
        const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");
      if (otp.length !== 4) {
        setOtpError(true);
        return;
      }
  
      setOtpError(false);
  
      makeApiRequest({
        url: `https://api-prod.daalchini.co.in/auth/user/login`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": deviceId || "",
        },
        data: {
          request: {
            deviceId: deviceId,
            fcmUserToken: null,
            mobileNo: number,
            otp: otp,
            requestId: google_requestId,
            sourcePlatform: "web",
          },
        },
        handleSuccess: (res) => {
          const response = res?.data?.response;
          if (response) {
            setGoogle_success_flag(true);
            setGoogle_OTP_Pop_flag(false);
            localStorage.setItem("UserJWTAuth", response.jwt);
            localStorage.setItem("referCode", response.referCode);
            localStorage.setItem("isUserLogged", response.isUserLogged);
            localStorage.setItem("isGuest", response.isGuest);
            localStorage.setItem("isTokenExpired", response.isTokenExpired);
          } else if (res?.data?.status === "FAILURE") {
            setOtpError(true);
            setOtpErrorMsg(res?.data?.statusMessage);
          }
        },
        handleError: () => setOtpError(true),
      });
    };
  
  

return (
  <>
       {(google_success_flag)&&<GoogleSuccessModal/>}
     {(google_OTP_Pop_flag&&google_OTP_Pop_flag)&&<GoogleNumberOtpModal setOtp={setOtp} otp={otp} googleOtpSubmit={googleOtpSubmit} closeOTpPop={closeOTpPop} google_OTP_Pop_flag={google_OTP_Pop_flag}/>}
    {(google_Pop_flag)&&!(localStorage.getItem("isGuest"))&&<AddGoogleNumber google_Pop_flag={google_Pop_flag}  googleAddnumber={googleAddnumber}closePop={closePop} setNumber={setNumber} number={number} numberError={numberError}numberErrorMsg={numberErrorMsg}/>}

{<LowBalanceModal open={flagLowBalance} onClose={Close}/> }
    {paymentStatusFlag ? (
      <>
        <PaymentStatus onTimerComplete={RedirectAfterPaymentStatus}   status={setOrderSucessStatus}
  amount ={"100"}
  orderId ={orderSucessOrderId}  paymentMethod={orderSucessPaymentMethod} />
      </>
    ) : (
      <>
        {loader && <WaitingLoder />}
        {false && <AutoApplyPopup />}
        {openEmptyCart&&<EmptyCartDialog setOpenEmptyCart={setOpenEmptyCart} openEmptyCart={openEmptyCart} clearPreCart={clearPreCart}/>}
        {showCouponPopFlag && (
          <CouponDialog
            CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}
          />
        )}
        <MyHeader  handleBack={handleBack} handleEmpty={handleEmpty}/>
        <CartList
          cartList={cartList}
          increaseQuantity={handleCartOpertation}
          decreaseQuantity={handleCartOpertation}
          fetchCouponsList={fetchCouponsList}
          setShowCoupoListFlag={setShowCoupoListFlag}
          fullObjectRewardCart={fullObjectRewardCart}
          removebtnflag={removebtnflag}
        />
        <PaymentBottomBar
          paymentOptionData={paymentOptionData}
          CreateOrderApi={CreateOrderApi}
          fullObjectRewardCart={fullObjectRewardCart}
        />
      </>
    )}
  </>
);


}

export default MyCartContainer;